import { defineComponent as t, openBlock as o, createBlock as r, unref as n, withCtx as s, renderSlot as l } from "vue";
import p from "./ghl-ui.es278.js";
const f = t({
  name: "UICollapseTransition",
  inheritAttrs: !1
}), i = t({
  ...f,
  props: {
    appear: {
      type: Boolean,
      default: !1
    },
    show: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (a, u) => (o(), r(n(p), {
      appear: e.appear,
      show: e.show
    }, {
      default: s(() => [
        l(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["appear", "show"]));
  }
}), h = i;
export {
  h as default
};
